import React from "react";
import { useTranslation } from "react-i18next";
import useLangNavigate from "../common/useLangNavigate";
import FeatureCard from "../common/feature-card/FeatureCard";
import iWantToWriteNew from "../../assets/png/i-want-to-write-new.png";
import iAlreadyStarted from "../../assets/png/i-already-started.png";
import iHaveFinished from "../../assets/png/i-have-finished.png";

const LandingPage = () => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();

  const mainOptions = [
    {
      key: "new_book",
      name: t("landing.write_new_book"),
      description: t("landing.write_new_book_desc"),
      icon: iWantToWriteNew,
      action: () => navigate("/writing-mode/1/new"),
    },
    {
      key: "reformulate_book",
      name: t("landing.continue_book"),
      description: t("landing.continue_book_desc"),
      icon: iAlreadyStarted,
      action: () => navigate("/general-categories/1/reformulate"),
    },
    {
      key: "finished_book",
      name: t("landing.finished_book"),
      description: t("landing.finished_book_desc"),
      icon: iHaveFinished,
      action: () => navigate("/finished-book-options"),
    },
  ];

  return (
    <section className="aai-features py-100 landing-page-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="aai-section-title mb-5 text-center">
              <h2 className="section-title">{t("landing.main_title")}</h2>
              <p className="section-desc">{t("landing.main_subtitle")}</p>
            </div>
          </div>
        </div>

        {/* Main Options */}
        <div className="row">
          {mainOptions.map((item, index) => {
            const icon = item.icon || null;
            return (
              <FeatureCard
                key={`main-option-${index}`}
                onClick={item.action}
                img={icon}
                name={item.name}
                description={item.description}
                showArrow={true}
                variant="landing"
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
